export default __webpack_public_path__ + "./image/68173e2f69851a2b92d8f1b5209f358b.png";